module.exports = __webpack_public_path__ + "static/img/Playmix-logo.20b4186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/playmix/imgs/Playmix-logo.png
// module id = 2447
// module chunks = 0